interface InnerProps {
    children: React.ReactNode;
    type?: 'pc' | 'mobile';
    className?: string;
}

// 컨텐츠영역 커스텀 함수
export function Inner({ children, type, className }: InnerProps) {
    const base = 'px-[16px]';
    const pc = 'w-full pc:max-w-[1200px] pc:mx-auto pc:px-0';
    const mobile = '';

    return (
        <div className={`${base} ${type === 'pc' ? pc : ''} ${type === 'mobile' ? mobile : ''} ${className || ''}`}>
            {children}
        </div>
    );
}